<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <!-- <CCardHeader class="d-flex align-items-center justify-content-between">
          <strong>Payment History</strong>
          <button type="button" class="btn btn-text btn-text-primary" @click="back">Back</button>
        </CCardHeader> -->
        <CCardBody>
          <!-- ================= How many payments ================= -->
          <CRow class="mb-3" v-if="summary">
            <CCol sm="6" lg="3">
              <div class="summary-box">
                <small>Total Payments</small>
                <strong>{{ summary.totalPayments }}</strong>
              </div>
            </CCol>
            <CCol sm="6" lg="3" v-for="s in summary.byStatus" :key="'st' + s.status">
              <div class="summary-box">
                <small>{{ s.label }}</small>
                <strong>{{ s.count }}</strong>
              </div>
            </CCol>
            <CCol sm="6" lg="3">
              <div class="summary-box">
                <small>Online / Offline</small>
                <strong>{{ summary.online }} / {{ summary.offline }}</strong>
              </div>
            </CCol>
            <CCol sm="6" lg="3">
              <div class="summary-box">
                <small>Rejected (Offline)</small>
                <strong>{{ summary.rejected }}</strong>
              </div>
            </CCol>
            <CCol sm="12" lg="6">
              <div class="summary-box">
                <small>Received (successful)</small>
                <strong v-if="!summary.amounts.length">0</strong>
                <strong class="mr-3" v-for="a in summary.amounts" :key="'cur' + a.currency">
                  {{ a.currency }} {{ formatAmount(a.amount) }}
                </strong>
              </div>
            </CCol>
          </CRow>

          <!-- ================= Filters ================= -->
          <!-- <CRow class="mb-2">
            <CCol md="3">
              <input type="text" class="form-control form-control-sm" placeholder="Search name / transaction id"
                v-model.trim="filters.searchText" @keyup.enter="load(1)" />
            </CCol>
            <CCol md="2">
              <select class="form-control form-control-sm" v-model="filters.status" @change="load(1)">
                <option value="">All status</option>
                <option v-for="o in statusOptions" :key="'so' + o.value" :value="o.value">{{ o.label }}</option>
              </select>
            </CCol>
            <CCol md="2">
              <select class="form-control form-control-sm" v-model="filters.mode" @change="load(1)">
                <option value="">Online + Offline</option>
                <option value="online">Online</option>
                <option value="offline">Offline</option>
              </select>
            </CCol>
            <CCol md="2">
              <input type="date" class="form-control form-control-sm" v-model="filters.fromDate" @change="load(1)" />
            </CCol>
            <CCol md="2">
              <input type="date" class="form-control form-control-sm" v-model="filters.toDate" @change="load(1)" />
            </CCol>
            <CCol md="1" class="text-right">
              <button type="button" class="btn btn-text btn-text-danger" @click="resetFilters">Reset</button>
            </CCol>
          </CRow> -->

          <!-- ================= List ================= -->
          <CDataTable :items="items" :fields="fields" :loading="loading" hover striped border small
            :noItemsView="{ noResults: 'No payments found', noItems: 'No payments yet' }">
            <template #fromName="{ item }">
              <td>
                {{ item.fromName || "-" }}
                <small class="d-block text-muted" v-if="item.fromTitle">{{ item.fromTitle }}</small>
              </td>
            </template>
            <template #amount="{ item }">
              <td class="text-nowrap">
                <strong>{{ item.currency }} {{ formatAmount(item.totalPoints) }}</strong>
                <small class="d-block text-muted">
                  {{ formatAmount(item.points) }} + fee {{ formatAmount(item.transactionFee) }} + GST {{ formatAmount(item.gst) }}
                </small>
              </td>
            </template>
            <template #mode="{ item }">
              <td>
                <CBadge :color="item.isOfflinePay ? 'info' : 'primary'">{{ item.isOfflinePay ? "Offline" : "Online" }}</CBadge>
                <small class="d-block">{{ item.paymentMethod || "" }}</small>
              </td>
            </template>
            <template #status="{ item }">
              <td>
                <CBadge :color="item.isRejected ? 'danger' : statusColor(item.statusLabel)">
                  {{ item.isRejected ? "Rejected" : item.statusLabel }}
                </CBadge>
                <small class="d-block text-danger" v-if="item.isRejected && item.offlineRejectReason">
                  {{ item.offlineRejectReason }}</small>
              </td>
            </template>
            <template #transactionId="{ item }">
              <td class="text-break">{{ item.transactionId || item.paymentId || "-" }}</td>
            </template>
            <template #actions="{ item }">
              <td class="text-nowrap">
                <a v-if="item.receipt" :href="fileUrl(item.receipt)" target="_blank" rel="noopener"
                  class="btn btn-text btn-text-primary">Receipt</a>
                <a v-if="item.offlineAttachment" :href="fileUrl(item.offlineAttachment)" target="_blank" rel="noopener"
                  class="btn btn-text btn-text-primary">Attachment</a>
              </td>
            </template>
          </CDataTable>

          <CPagination v-if="pages > 1" :activePage.sync="page" :pages="pages" align="end"
            @update:activePage="load" />
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import store from "/src/store/store.js";

// TODO: folder where offline payment attachments / receipts are stored
const FILE_BASE_URL = "https://s3.ap-south-1.amazonaws.com/resourceful-test/payments/";

const emptyFilters = () => ({
  searchText: "",
  status: "",
  mode: "",
  fromDate: "",
  toDate: "",
});

export default {
  name: "InstituteChainPaymentHistory",
  data() {
    return {
      chainId: this.$route.params.id,
      loading: false,
      items: [],
      summary: null,
      statusOptions: [],
      page: 1,
      pages: 1,
      limit: 10,
      filters: emptyFilters(),
      fields: [
        { key: "transactionDate", label: "Date" },
        { key: "fromName", label: "Paid By" },
        { key: "amount", label: "Amount" },
        { key: "mode", label: "Mode" },
        { key: "status", label: "Status" },
        { key: "transactionId", label: "Transaction ID" },
        { key: "actions", label: "Actions", sorter: false, filter: false },
      ],
    };
  },
  mounted() {
    store.commit("showLoader", false);
    this.load(1);
  },
  methods: {
    load(page) {
      this.page = page;
      this.loading = true;
      // TODO: swap for your url helper if you add it to store/url.js
      axios
        .post(`/institute-chain/${this.chainId}/payment-history`, {
          ...this.filters,
          page,
          limit: this.limit,
        })
        .then(({ data }) => {
          const body = data || {};
          // Works with both shapes:
          //   { data: [rows], count, summary }            (rows directly in data)
          //   { data: { data: [rows], count, summary } }  (rows one level deeper)
          const res = Array.isArray(body.data) ? body : body.data || body.response || {};
          this.items = Array.isArray(res.data) ? res.data : [];
          this.summary = res.summary || body.summary || null;
          this.statusOptions = (this.summary && this.summary.statusOptions) || [];
          const total = res.count !== undefined ? res.count : body.count !== undefined ? body.count : this.items.length;
          this.pages = Math.max(1, Math.ceil(Number(total || 0) / this.limit));
        })
        .catch((error) => {
          console.error("Payment history load failed", error);
          this.items = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    resetFilters() {
      this.filters = emptyFilters();
      this.load(1);
    },
    // Colour follows the label sent by the backend, so the status numbers live in one place
    statusColor(label) {
      const l = String(label || "").toLowerCase();
      if (["success", "approved", "completed", "paid"].includes(l)) return "success";
      if (["pending", "processing"].includes(l)) return "warning";
      if (["failed", "rejected", "cancelled", "canceled"].includes(l)) return "danger";
      return "secondary";
    },
    formatAmount(value) {
      return Number(value || 0).toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    // Attachment / receipt may come as a bare file name; full URLs are used as-is
    fileUrl(path) {
      if (!path) return "";
      if (/^https?:\/\//i.test(path)) return path;
      return FILE_BASE_URL + path;
    },
    back() {
      this.$router.push({ path: "/institute-chain" });
    },
  },
};
</script>

<style>
.summary-box {
  border: 1px solid #d8dbe0;
  border-radius: 0.25rem;
  padding: 0.6rem 0.9rem;
  margin-bottom: 0.75rem;
}
.summary-box small {
  display: block;
  color: #768192;
}
.summary-box strong {
  font-size: 1.15rem;
}

/* Text-only buttons: no background until hover */
.btn-text {
  background: transparent;
  border: 1px solid transparent;
  padding: 0.25rem 0.75rem;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.5;
  border-radius: 0.25rem;
  box-shadow: none;
  transition: background-color 0.15s ease, color 0.15s ease;
}
.btn-text:focus {
  box-shadow: none;
}
.btn-text-primary {
  color: #321fdb;
}
.btn-text-primary:hover:not(:disabled),
.btn-text-primary:focus-visible {
  background-color: #321fdb;
  color: #fff;
}
.btn-text-danger {
  color: #e55353;
}
.btn-text-danger:hover:not(:disabled),
.btn-text-danger:focus-visible {
  background-color: #e55353;
  color: #fff;
}
.btn-text:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
</style>